const getMemberValues = (memberIndex, activeCommittee) => {
    return {
        views: activeCommittee.members[memberIndex].value_views,
        evidence: activeCommittee.members[memberIndex].value_evidence,
    };
};

export const getCommitteeScores = (committeeMembers, activeCommittee) => {
    let totalEvidence = 0;
    let totalViews = 0;
    return committeeMembers.reduce((obj, memberIndex) => {
        const memberValues = getMemberValues(memberIndex, activeCommittee);
        totalEvidence += memberValues.evidence;
        totalViews += memberValues.views;
        return {
            ...obj,
            evidence: totalEvidence / 5,
            views: totalViews / 5,
        };
    }, {});
};

const getTargetsHit = (committeeMembers, activeCommittee) => {
    const committeeScores = getCommitteeScores(
        committeeMembers,
        activeCommittee,
    );

    const committeeEvidenceTargetHit =
        activeCommittee.value_evidence < committeeScores.evidence ? 1 : 0;
    const committeeViewsTargetHit =
        activeCommittee.value_views < committeeScores.views ? 1 : 0;

    return committeeEvidenceTargetHit + committeeViewsTargetHit;
};

export const getCommitteeGameScores = (committeeMembers, activeCommittee) => {
    const targetsHit = getTargetsHit(committeeMembers, activeCommittee);

    const result = activeCommittee.result.filter(
        result => result.targetsReached === targetsHit,
    )[0];

    return {
        scores: {
            party: result.score_party,
            voters: result.score_local,
            media: result.score_media,
        },
        feedback: result.feedback,
    };
};
